// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld/base/core';
import './fieldEditor';
import 'myWorld/uiComponents/form/customDropDown';

/**
 * Input for the sharing field. Shows up as a multilevel menu
 * @name SharingFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.SharingFieldEditor = myw.FieldEditor.extend({
    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.options = options;
        this.isOpen = false;

        this.control = new SharingDropDown({
            system: this.app.system,
            options: this.fieldDD.enumValues,
            value: this.fieldValue
        });
        this.setElement(this.control.$el);

        const subMenuIcon = $('<span>', { class: 'ui-menu-icon ui-icon ui-icon-caret-1-e' });

        this.control.list
            .find("li[name='group']")
            .attr('role', 'no-select')
            .addClass('group-option')
            .children('div')
            .append(subMenuIcon); //jquery-ui menu doesnt add this icon for some reason
    }
});

const SharingDropDown = myw.CustomDropDown.extend({
    getDisplayValue(val) {
        if (val && val.split(':').length > 1) return val.split(':')[1];
        else return val;
    },

    _setSelectedOptionFromItem(item) {
        const selectedText = $.trim(item.text());
        return typeof item.attr('data') !== 'undefined' ? item.attr('data') : selectedText;
    },

    getValue() {
        const defaultSelection = this.options.args ? this.options.args.defaultSelection : null;
        return this.selectedOption || this.options.value || defaultSelection;
    },

    toggleMenu() {
        myw.CustomDropDown.prototype.toggleMenu.apply(this);
        if (this.isOpen) this._updateGroupSelector();
    },

    _updateGroupSelector() {
        if (!this.groupSelector) {
            this.groupSelector = new myw.UserGroupSelector({
                system: this.options.system,
                isSubMenu: true
            });
            this.groupSelector.render();
        }

        this.groupSelector.populateOptions().then(gpSelect => {
            //Add the group selector as a sub menu for the group option
            this.list.find("li[name='group']").append(gpSelect.hide());
        });
    }
});

export default myw.SharingFieldEditor;
